@if (mode == 'mobile' || courses.length < 2) {
  <div style="margin: 0 20px;">
    <div class="page-column">
      <app-logo/>
      <!-- <router-outlet /> -->
    </div>
    <div class="page-column-tight">
      <mat-divider class="primary"></mat-divider>
    </div>
    <div class="page-row-blank">
      <mat-form-field class="formfield" hideRequiredMarker subscriptSizing="dynamic">
        <mat-label>{{ 'courses.type' | transloco }}</mat-label>
        <mat-select (valueChange)="loadGroups($event)" [formControl]="categoryForm">
          @for (dto of categories; track dto.name) {
            <mat-option [value]="dto.name">
              {{ dto.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="page-row-blank">
      <div class="column">
        @for (dto of courses; track dto.id) {
          <app-course-card (cardClicked)="onCardClicked(dto)" [dto]="dto"/>
        }
      </div>
    </div>
  </div>
} @else {
  <div style="margin: 0 20px;">
    <div class="page-column">
      <app-logo/>
    </div>
    <div class="page-column-tight">
      <mat-divider class="primary"></mat-divider>
    </div>
    <div class="page-row-blank">
      <mat-form-field class="formfield" hideRequiredMarker subscriptSizing="dynamic">
        <mat-label>{{ 'courses.type' | transloco }}</mat-label>
        <mat-select (valueChange)="loadGroups($event)" [formControl]="categoryForm">
          @for (dto of categories; track dto.name) {
            <mat-option [value]="dto.name">
              {{ dto.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="page-row-blank">
      <div class="columnLeft">
        @for (dto of coursesLeft(); track dto.id) {
          <app-course-card (cardClicked)="onCardClicked(dto)" [dto]="dto"/>
        }
      </div>
      <div class="columnRight">
        @for (dto of coursesRight(); track dto.id) {
          <app-course-card (cardClicked)="onCardClicked(dto)" [dto]="dto"/>
        }
      </div>
    </div>
  </div>
}
